import modelApi from "~/backend/modelApi";
import { default as  defaultAuthenticatedRequest} from "~/backend/authenticatedRequest";

const fetchManyResults = async (baseUrl, options, authenticatedRequest = defaultAuthenticatedRequest) => {
    let resultIndex = [],
        promises = [];

    for(let i = 0; i < options.length; i++) {
        let {params, cancel, modelName}  = options[i];

        const { fetchResults } = modelApi(baseUrl, modelName, authenticatedRequest);
        promises.push(fetchResults(params, cancel));
        resultIndex[i] = modelName;
    }

    let results = await Promise.all(promises);

    let indexedResults = {};

    for(let i = 0; i < results.length; i++) {
        indexedResults[resultIndex[i]] = results[i];
    }

    return indexedResults;
};


export default fetchManyResults;